var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpensSectionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7828_2757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 15.934L12.5449 11.9997L8.57153 8.06544L9.79478 6.85687L15.0001 11.9997L9.79478 17.1426L8.57153 15.934Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpensSectionArrow);
export default __webpack_public_path__ + "static/media/opensSectionArrow.22acb9ec.svg";
export { ForwardRef as ReactComponent };